exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-account-components-Profile-___style__loadContainer___1jxV9{text-align:center;margin:1rem;background-color:#fff;border:1px solid #e5e3e3;padding:1rem}.web-flows-account-components-Profile-___style__profile___3b1oD{margin:1rem;display:flex;background-color:#fff;border:1px solid #e5e3e3;padding:.5rem 1.5em}@media (max-width:599px){.web-flows-account-components-Profile-___style__profile___3b1oD{flex-direction:column}}.web-flows-account-components-Profile-___style__detail___35Knr{font-weight:700;flex-grow:1}.web-flows-account-components-Profile-___style__detail___35Knr>span{font-weight:400}", ""]);

// exports
exports.locals = {
	"loadContainer": "web-flows-account-components-Profile-___style__loadContainer___1jxV9",
	"profile": "web-flows-account-components-Profile-___style__profile___3b1oD",
	"detail": "web-flows-account-components-Profile-___style__detail___35Knr"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/account/components/Profile/style.css
// module id = 1335
// module chunks = 0